import { useMemo } from "react"

export default function Latitude(props){
    const {params} = props
    const lat = useMemo(() => {
        const {row} = params
        return row?.geometry?.coordinates[1]
    },[params])

    return (
        <>
            <div>{lat}</div>
        </>
    )
}